import { useTranslation } from 'react-i18next';
import type { CustomDomainStatusReason } from '@/api/customDomains/customDomainsApi.types';

interface CustomDomainReasonMessageProps {
  reason: CustomDomainStatusReason;
  shouldShowFix: boolean;
}

export function CustomDomainReasonMessage({
  reason,
  shouldShowFix,
}: CustomDomainReasonMessageProps) {
  const { t } = useTranslation('customDomains');
  return (
    <div className="rounded-xl bg-zoowarningbg border border-zoowarningtext border-opacity-30 p-3">
      <p className="text-xs font-bold text-zoowarningtext">{t('reasons.' + reason + '.message')}</p>
      {shouldShowFix === true ? (
        <p className="text-xs text-zooindigo mt-1">{t('reasons.' + reason + '.fix')}</p>
      ) : null}
    </div>
  );
}
